// extracted by mini-css-extract-plugin
export var externalLink = "_ag-0";
export var internalLinkLabel = "_ag-1";